import React from 'react';

// Import all brand images
import Aquafina from './brands/Aquafina.JPG';
import Bubly from './brands/bubly.JPG';
import MtnDew from './brands/mtndew.PNG';
import Country from './brands/country.jpg';
import Brisk from './brands/brisk.PNG';
import MugRootBeer from './brands/mug_root_beer.JPG';
import ZenWtr from './brands/zenwtr.JPG';
import Evian from './brands/evian.PNG';
import DrBrown from './brands/drbrown.PNG';
import GFuel from './brands/G_fuel.JPG';
import LifeWtr from './brands/lifewtr.PNG';
import Crush from './brands/crush.JPG';
import Rockstar from './brands/rockstar.PNG';
import Schweppes from './brands/schweppes.PNG';
import SierraMist from './brands/sierramist.PNG';
import Polar from './brands/polar.PNG';
import Starbucks from './brands/starbucks.PNG';
import Pepsi from './brands/pepsi.JPG';
import Manzanita from './brands/manzonita.JPG';
import Flow from './brands/flow.JPG';
import Good2Grow from './brands/good2grow.PNG';

const Brands = ({ onBrandClick }) => {
  const brands = [
    { name: 'Aquafina', image: Aquafina },
    { name: 'Bubly sparkling water', image: Bubly },
    { name: 'Mountain Dew', image: MtnDew },
    { name: 'Country time lemonade', image: Country },
    { name: 'Brisk', image: Brisk },
    { name: 'Mug Root Beer', image: MugRootBeer },
    { name: 'Zen Water', image: ZenWtr },
    { name: 'Evian Water', image: Evian },
    { name: 'Dr Brown', image: DrBrown },
    { name: 'G Fuel Energy Formular', image: GFuel },
    { name: 'Life Water', image: LifeWtr },
    { name: 'Crush', image: Crush },
    { name: 'Rockstar Energy Drink', image: Rockstar },
    { name: 'Schweppes', image: Schweppes },
    { name: 'Sierra Mist Soda', image: SierraMist },
    { name: 'Polar Beverages', image: Polar },
    { name: 'Starbucks', image: Starbucks },
    { name: 'Pepsi Drink', image: Pepsi },
    { name: 'Manzanita Sol', image: Manzanita },
    { name: 'Flow', image: Flow },
    { name: 'Good2grow', image: Good2Grow },
  ];

  return (
    <section 
      id="brands" 
      className="py-20 bg-cover bg-center bg-fixed relative"
      style={{ 
        backgroundImage: 'url(/images/brands_background.png)',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Overlay for better readability */}
      <div className="absolute inset-0 bg-black/40"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Our Brands</h2>
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-100 max-w-2xl mx-auto">
            We distribute a comprehensive selection of premium beverage brands. Click any brand to learn more.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
          {brands.map((brand, index) => (
            <button
              key={index}
              onClick={() => onBrandClick(brand.name)}
              className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 flex flex-col items-center justify-center aspect-square border border-gray-200 cursor-pointer hover:border-blue-500"
            >
              <img 
                src={brand.image} 
                alt={brand.name}
                className="w-24 h-24 object-contain mb-3"
              />
              <span className="font-bold text-center text-xs text-gray-700">{brand.name}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Brands;